"use client";

import { motion } from "motion/react";
import Link from "next/link";
import { Icon } from "@iconify/react";
import { contactCardsData } from "@/lib/contact-data";
import { containerVariants, itemVariants } from "@/utils/animations";

export default function ContactCards() {
  return (
    <section className="px-6 pb-24">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        // Matches the max-width of your Hero Section (83.75rem)
        className="max-w-[83.75rem] mx-auto grid md:grid-cols-2 gap-8"
      >
        {contactCardsData.map((card, idx) => (
          <motion.div
            key={idx}
            variants={itemVariants}
            className="group relative p-10 rounded-[2rem] border border-border dark:border-dark_border bg-white dark:bg-dark_b hover:border-primary/50 transition-all duration-300 shadow-xl shadow-border/40 dark:shadow-none hover:-translate-y-1 overflow-hidden"
          >
            {/* Subtle Gradient Hover Effect */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>

            <div className="relative z-10 flex flex-col sm:flex-row gap-8 items-start">
              {/* Icon Container using hero-bg */}
              <div className="w-16 h-16 rounded-2xl bg-hero-bg dark:bg-search border border-border dark:border-dark_border flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300 shrink-0">
                <Icon icon={card.icon} width="32" />
              </div>

              <div className="flex-1">
                <h3
                  className={`${card.titleSize} font-bold text-midnight_text dark:text-white mb-3`}
                >
                  {card.title}
                </h3>
                {/* Using text-muted as per your preference */}
                <p className="text-muted dark:text-foottext text-18 mb-8 leading-relaxed">
                  {card.description}
                </p>

                <Link
                  href={card.href}
                  className="inline-flex items-center gap-2 text-primary text-18 font-medium group-hover:text-midnight_text dark:group-hover:text-white transition-colors"
                >
                  {card.action}
                  <Icon
                    icon="ion:arrow-forward"
                    className="group-hover:translate-x-1 transition-transform"
                  />
                </Link>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
